import React, { useEffect, useContext } from 'react';
import {UserContext} from '@context/UserContext';
import {ContentContext} from '@context/ContentContext';
import TitleHeaderRight from "../nav/TitleHeaderRight";
import TitleNavigationDevelopment from "./TitleNavigationDevelopment";
import {BrandContext} from "@context/BrandContext";
import LessonTitleControls from "./LessonTitleControls";

const LessonTitle = props => {
    const {user} = useContext(UserContext);
    const {content} = useContext(ContentContext);
    const brandConfig = useContext(BrandContext);

    useEffect(() => {
        $('.ch-title .ch-mathjax').reloadMathJax();
    }, [content]);


    return (
        <div className={'js-header'}>
            <div className="ch-page-header" style={{backgroundImage: 'url(' + content.backgroundImage + ')', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                <div style={{marginRight: '2px'}}>
                    {content !== undefined && content.currentTopic !== undefined && (
                        <div className="ch-page-header-title lesson-title">
                            {user.showResourceIds &&
                                <span>#{content.currentTopic.topicId}&nbsp;</span>
                            }
                            <span>{content.currentTopic.topicName}</span>
                        </div>
                    )}
                    {content !== undefined && content.currentConcept !== undefined && (
                        <div className="ch-page-header-title lesson-title ch-page-header-title--main  padding-l--rm padding-r--rm">
                            <LessonTitleControls />
                        </div>
                    )}
                </div>
                {!user.publicSession && brandConfig.useDevelopmentNavigation ?
                    <TitleNavigationDevelopment /> :
                    <TitleHeaderRight />
                }
            </div>
        </div>
    )
}

export default LessonTitle;